import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Switcher between the two report families. Buttons rather than a mat-tab-nav-bar:
 * payment-reports already owns a mat-tab-group for Summary / Detailed / Daily
 * balancing, and a second tab row stacked above it reads as nested tabs.
 */
@Component({
  selector: 'app-reports-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatButtonModule, MatIconModule],
  template: `
    <div class="reports-nav">
      <a mat-flat-button routerLink="/app/reports" routerLinkActive #dist="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         [color]="dist.isActive ? 'primary' : undefined"
         [attr.aria-current]="dist.isActive ? 'page' : null">
        <mat-icon>pie_chart</mat-icon> Distribution
      </a>
      <a mat-flat-button routerLink="/app/reports/payment-reports" routerLinkActive #pay="routerLinkActive"
         [color]="pay.isActive ? 'primary' : undefined"
         [attr.aria-current]="pay.isActive ? 'page' : null">
        <mat-icon>payments</mat-icon> Payments
      </a>
    </div>
  `,
  styles: [`
    .reports-nav { display:flex; gap:12px; flex-wrap:wrap; }
    /* The inactive button keeps the filled shape so the pair reads as one control. */
    .reports-nav a:not(.mat-primary) { background:#ECEFF1; color:rgba(0,0,0,.72); }
    .reports-nav a:not(.mat-primary):hover { background:#DDE3E7; }
  `],
})
export class ReportsNavComponent {}
